import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";
import { callVersionEndpoint } from "../api";
import { ONE_HOUR } from "../const";

export const useInvalidateOnVersionChange = () => {
  const version = useRef(0);
  const queryClient = useQueryClient();

  const { data, isPending } = useQuery<number, Error>({
    queryKey: ["version"],
    queryFn: () => callVersionEndpoint(),
    refetchInterval: ONE_HOUR, // This is the only one that should be 1 hour
  });

  if (!isPending && data && data !== version.current) {
    version.current = data;
    queryClient.invalidateQueries();
  }
};
